import api from '@/services/api'

export const getOkrSummary = async (userId, periods) => {
    const response = await api.get(`users/${userId}/profile/okr-summary`, {
        params: { periods },
    })

    return response.data.data
}
